<div  [formGroup]="firstFormGroup" fxLayout="column" fxLayoutAlign="start stretch" class="dialog-container">

    <div class="top-border"></div>
  
    <button [attr.guide]="'crm-business-edit-btn-close' + '__' + sanitizeUrl(url)" mat-icon-button class="close-button" (click)="closeDialog()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  
    <h2>Personalize Calsoft for your business</h2>
    <p class="subtitle">You can rename these modules to match the terms you use at work.</p>
  
    <mat-card class="module-card" *ngFor="let module of 
     firstFormGroup.get('modules')['controls']; let i = index"
       formArrayName="modules">
     <div [formGroupName]="i">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
  
            <div fxFlex="60" fxFlex.xs="100">
      
              <mat-icon class="module-icon" aria-hidden="false">{{ modules[i].moduleIcons }}</mat-icon>
      
              <!-- Show when not editing -->
              <div fxFlex *ngIf="editIndex !== i">
                <h3>{{ modules[i].moduleName }}</h3>
                <p>{{ modules[i].description }}</p>
              </div>
      
              <!-- Show when editing -->
              <div *ngIf="editIndex === i" fxFlex fxLayout="row" fxLayout.xs="column"
                  fxLayoutAlign="space-between center" fxLayoutGap="16px">
      
                <div fxFlex fxLayout="row" fxLayoutGap="16px">
                  <mat-icon class="module-icon" fxHide.xs aria-hidden="false">{{ modules[i].moduleIcons }}</mat-icon>
                  <mat-form-field appearance="outline" class="custom-input">
                    <mat-label>Module name</mat-label>
                    <input [attr.guide]="'crm-business-edit-inp-modulename' + '__' + sanitizeUrl(url)" readonly matInput formControlName="moduleName" required/>
                  </mat-form-field>
                </div>
      
                <div fxFlex>
                  <mat-form-field appearance="outline" class="custom-input">
                    <mat-label>Name in plural</mat-label>
                    <input [attr.guide]="'crm-business-edit-inp-displayname' + '__' + sanitizeUrl(url)" matInput formControlName="displayName" required/>
                  </mat-form-field>
                </div>
      
                <button [attr.guide]="'crm-business-edit-btn-1' + '__' + sanitizeUrl(url)" mat-stroked-button color="primary" (click)="saveCustomNames(i)">
                  <mat-icon>check</mat-icon> Done
                </button>
              </div>
            </div>
      
            <div fxFlex="40" fxFlex.xs="100" fxLayout="row" fxLayout.xs="column"
                fxLayoutAlign="end center" fxLayoutAlign.xs="start center" class="other-names" *ngIf="editIndex !== i">
              <div class="suggestion">
                <p style="color: #3f51b5;">{{ modules[i].displayName }}</p>
              </div>
              <div>
                <button [attr.guide]="'crm-business-edit-btn-2' + '__' + sanitizeUrl(url)" (click)="enableEditNew(i)" mat-button class="add-own">
                  <mat-icon>edit</mat-icon>
                  <span>Add your own</span>
                </button>
              </div>
            </div>
          </div>

     </div>
     
    </mat-card>
  
    <div *ngIf="enableSync" fxLayout="row" fxLayoutAlign="center center" class="footer-buttons">
      <button [attr.guide]="'crm-business-edit-btn-3' + '__' + sanitizeUrl(url)" [disabled]="textsysn != 'Sync'" class="primarybtn" (click)="syncModule()" mat-raised-button>
        {{textsysn}}
        <mat-icon *ngIf="textsysn != 'Sync' ">
          <mat-spinner color="primary" diameter="20"></mat-spinner>
        </mat-icon>
      </button>
    </div>
  
    <div fxLayout="row" *ngIf="!enableSync" fxLayoutAlign="center center" class="footer-buttons">
      <button [attr.guide]="'crm-business-edit-btn-4' + '__' + sanitizeUrl(url)" mat-button (click)="closeDialog()">Cancel</button>
      <button [attr.guide]="'crm-business-edit-btn-5' + '__' + sanitizeUrl(url)" [disabled]="text != 'Save'" class="primarybtn" (click)="saveModulesName()" mat-raised-button>
        {{text}}
        <mat-icon *ngIf="text != 'Save' ">
          <mat-spinner color="primary" diameter="20"></mat-spinner>
        </mat-icon>
      </button>
    </div>
  </div>
  